import { put, call, all, takeLatest } from 'redux-saga/effects'
// import store from 'store';
import actions from './actions'
import { getTags, setTag } from '../../services/tags'

const token = state => state.app.user.token
// const userName = state => state.app.user.nickname;

function delay(duration) {
  const promise = new Promise(resolve => {
    setTimeout(() => resolve(true), duration)
  })
  return promise
}

export function* fetchTags(value) {
  try {
    const { path } = value.payload
    const { data } = yield call(() => getTags(token, path))
    yield put({
      type: actions.FETCH_TAGS_SUCCESS,
      data,
    })
    yield call(delay, 4000)
  } catch (error) {
    yield put({ type: actions.FETCH_TAGS_ERROR, message: error.message })
  }
}

export function* setTagValue(data) {
  const { tagpath, tagvalue } = data.payload
  // console.log('mandar:', JSON.stringify(data.payload))
  const dt = new Date()
  const dts = dt.toISOString()
  const tag = {
    dateTime: dts,
    value: tagvalue,
    path: tagpath,
    origin: 'plain4.com',
  }
  // console.log('enviando:', JSON.stringify(tag))
  yield call(setTag, tag, token)
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.FETCH_TAGS, fetchTags),
    takeLatest(actions.TAG_SET_VALUE, setTagValue),
    // poolSagaWorker()
  ])
}
